'use strict';
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = JSON.parse($('#VexiRoutes')?.textContent || '{"root":"/","cart":"/cart"}');
  let busy = false, quickController, toastTimer, cartRevision = 0;
  const origins = new WeakMap();
  const notice = message => {
    const node = $('#theme-toast');
    if (!node) return;
    node.textContent = message; node.classList.add('visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => node.classList.remove('visible'), 3500);
  };
  const closeDialog = dialog => {
    if (!dialog?.open) return;
    dialog.close();
  };
  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    $$('dialog[open]').filter(d => d !== dialog).forEach(closeDialog);
    origins.set(dialog, trigger || document.activeElement);
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('vx-modal-open');
  };
  const bindDialogs = () => $$('dialog').forEach(dialog => {
    if (dialog.dataset.vxBound) return;
    dialog.dataset.vxBound = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('vx-modal-open');
      const origin = origins.get(dialog);
      if (origin?.isConnected) origin.focus();
      if (dialog.id === 'QuickView') {
        quickController?.abort();
        $$('video', dialog).forEach(v => v.pause());
        $$('iframe', dialog).forEach(f => f.remove());
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
    });
  });
  bindDialogs();
  const showMedia = (root, id) => {
    const template = $(`[data-media-template="${id}"]`, root), target = $('[data-primary-media]', root);
    if (!template || !target) return;
    $$('video', target).forEach(v => v.pause());
    target.replaceChildren(template.content.cloneNode(true));
    $$('[data-media-select]', root).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaSelect === String(id))));
  };
  const updateVariant = select => {
    const root = select.closest('[data-product-root]'), option = select.selectedOptions[0];
    if (!root || !option) return;
    const available = option.dataset.available === 'true', price = $('[data-product-price]', root), compare = $('[data-compare-price]', root), add = $('[data-add-button]', root), stock = $('[data-stock]', root);
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true'; }
    if (stock) stock.textContent = available ? 'Available' : 'Sold out';
    if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag +' : 'Sold out'; }
    if (option.dataset.mediaId) showMedia(root, option.dataset.mediaId);
    if (!root.closest('#QuickView')) {
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    }
  };
  const cartSections = () => ['cart-drawer', $('[data-main-cart]')?.dataset.cartSection].filter(Boolean);
  const fragment = (html, selector) => {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };
  const paintCart = sections => {
    let drawerUpdated = false;
    for (const id of cartSections()) {
      const next = fragment(sections?.[id], '[data-cart-fragment]');
      const scope = id === 'cart-drawer' ? $('#shopify-section-cart-drawer') : $('[data-main-cart]');
      const old = scope && $('[data-cart-fragment]', scope);
      if (next && old) {
        old.replaceWith(next);
        $$('[data-cart-count]').forEach(n => { n.textContent = next.dataset.count || '0'; });
        if (id === 'cart-drawer') drawerUpdated = true;
      }
    }
    return drawerUpdated;
  };
  const refreshCart = async () => {
    const revision = cartRevision;
    const url = new URL(config.cart, location.origin); url.searchParams.set('sections', cartSections().join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh your bag. Open the full bag to review your items.');
    const sections = await response.json();
    if (revision !== cartRevision) return;
    if (!paintCart(sections)) throw new Error('Your bag changed, but the drawer could not refresh. Open the full bag to review it.');
  };
  const setCartBusy = active => {
    for (const scope of [$('#CartDrawer'), $('[data-main-cart]')].filter(Boolean)) {
      scope.setAttribute('aria-busy', String(active));
      $$('[data-cart-change], [data-cart-quantity], button[name="checkout"]', scope).forEach(n => {
        if (n.tagName === 'A') n.setAttribute('aria-disabled', String(active)); else n.disabled = active;
      });
    }
  };
  const clearErrors = () => $$('[data-cart-error], [data-cart-page-error], [data-product-error]').forEach(n => { n.textContent = ''; });
  const showError = (error, form) => {
    const message = error.message || 'Please try again.';
    const target = form && $('[data-product-error]', form);
    if (target) target.textContent = message;
    $$('[data-cart-error], [data-cart-page-error]').forEach(n => { n.textContent = message; });
    notice(message);
  };
  const mutation = async (path, body) => {
    cartRevision += 1;
    const response = await fetch(config.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: cartSections(), sections_url: config.cart }) });
    const result = await response.json();
    if (!response.ok) {
      const detail = result.description || result.message;
      throw new Error(typeof detail === 'string' ? detail : 'This quantity is unavailable. Please review your bag.');
    }
    if (!paintCart(result.sections)) await refreshCart();
    return result;
  };
  const addProduct = async form => {
    if (busy) return;
    const button = $('button[type="submit"]', form), oldText = button?.textContent;
    busy = true; clearErrors(); setCartBusy(true);
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const fd = new FormData(form), variant = fd.get('id'), quantity = Number(fd.get('quantity') || 1);
      if (!variant || !Number.isInteger(quantity) || quantity < 1) throw new Error('Please choose a valid option and quantity.');
      const item = { id: variant, quantity };
      const properties = {};
      for (const [key, value] of fd.entries()) if (/^properties\[.*\]$/.test(key)) properties[key.slice(11, -1)] = value;
      if (Object.keys(properties).length) item.properties = properties;
      if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
      await mutation('cart/add.js', { items: [item] });
      closeDialog($('#QuickView'));
      openDialog($('#CartDrawer'), form.closest('#QuickView') ? $('[data-cart-open]') : button);
      notice('Added to your bag.');
    } catch (error) { showError(error, form); }
    finally {
      busy = false; setCartBusy(false);
      if (button) {
        button.textContent = oldText;
        const option = $('[data-variant-select]', form)?.selectedOptions[0];
        button.disabled = option ? option.dataset.available !== 'true' : false;
      }
    }
  };
  const changeCart = async (key, quantity, trigger) => {
    if (busy) return;
    if (!Number.isInteger(quantity) || quantity < 0) { notice('Please enter a whole quantity, zero or more.'); return; }
    const oldLine = trigger.closest('[data-cart-line]'), oldScope = trigger.closest('#CartDrawer') || trigger.closest('[data-main-cart]');
    const position = oldScope ? $$('[data-cart-line]', oldScope).indexOf(oldLine) : -1;
    busy = true; clearErrors(); setCartBusy(true);
    try {
      await mutation('cart/change.js', { id: key, quantity });
      notice(quantity === 0 ? 'Removed from your bag.' : 'Your bag is updated.');
    } catch (error) {
      try { await refreshCart(); } catch {}
      showError(error);
    } finally {
      busy = false; setCartBusy(false);
      if (oldScope) {
        const lines = $$('[data-cart-line]', oldScope);
        const line = lines.find(n => n.dataset.cartLine === key) || lines[Math.min(position, lines.length - 1)];
        const focus = line ? $('[data-cart-quantity]', line) : $('[data-close-dialog], a', oldScope);
        focus?.focus();
      }
    }
  };
  const loadQuick = async anchor => {
    const dialog = $('#QuickView'), content = $('[data-quick-content]', dialog);
    if (!dialog || !content) return;
    quickController?.abort(); quickController = new AbortController();
    content.innerHTML = '<p class="vx-loading" role="status">Loading product details…</p>';
    openDialog(dialog, anchor);
    try {
      const url = new URL(anchor.dataset.quickView, location.origin); url.searchParams.set('view', 'quick');
      const response = await fetch(url, { signal: quickController.signal });
      if (!response.ok) throw new Error('Unable to load this product.');
      const result = fragment(await response.text(), '[data-quick-product]');
      if (!result) throw new Error('Please view the full product page.');
      content.replaceChildren(result); const label = $('h2', result)?.textContent;
      $('#QuickViewTitle').textContent = label || 'Product quick view';
      $$('[data-variant-select]', result).forEach(updateVariant);
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.replaceChildren(); const p = document.createElement('p'); p.className = 'vx-loading'; p.textContent = error.message;
      const link = document.createElement('a'); link.href = anchor.dataset.quickView; link.className = 'button dark'; link.textContent = 'View product details ↗';
      content.append(p, link);
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('.vx-ajax-product')) { event.preventDefault(); addProduct(form); }
    else if (busy && form.closest('#CartDrawer, [data-main-cart]')) event.preventDefault();
  });
  document.addEventListener('click', event => {
    const target = event.target;
    const close = target.closest('[data-close-dialog]'); if (close) { closeDialog(close.closest('dialog')); return; }
    const opener = target.closest('[data-open-dialog]'); if (opener) { openDialog(document.getElementById(opener.dataset.openDialog), opener); return; }
    const cart = target.closest('[data-cart-open]'); if (cart) { event.preventDefault(); openDialog($('#CartDrawer'), cart); if (!busy) refreshCart().catch(error => showError(error)); return; }
    const quick = target.closest('[data-quick-view]'); if (quick) { event.preventDefault(); loadQuick(quick); return; }
    const change = target.closest('[data-cart-change]'); if (change) { event.preventDefault(); changeCart(change.dataset.cartChange, Number(change.dataset.quantity), change); return; }
    const media = target.closest('[data-media-select]'); if (media) { showMedia(media.closest('[data-product-root]'), media.dataset.mediaSelect); return; }
    const quantity = target.closest('[data-product-quantity]'); if (quantity) {
      const input = $('input[name="quantity"]', quantity.parentElement);
      if (input) input.value = String(Math.max(1, Number(input.value || 1) + Number(quantity.dataset.productQuantity)));
    }
    if (target.closest('#CollectionMenu a')) closeDialog($('#CollectionMenu'));
  });
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-variant-select]')) updateVariant(target);
    if (target.matches('[data-cart-quantity]')) {
      if (!target.value.trim()) { notice('Please enter a quantity.'); return; }
      changeCart(target.dataset.cartQuantity, Number(target.value), target);
    }
    if (target.matches('[data-sort-select]')) target.form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', () => { bindDialogs(); $$('[data-variant-select]').forEach(updateVariant); });
  $$('[data-variant-select]').forEach(updateVariant);
  window.addEventListener('pageshow', event => { if (event.persisted && !busy) refreshCart().catch(() => {}); });
})();
